type BorderLHS = 'border' | 'border-left' | 'border-right' | 'border-top' | 'border-bottom';

const styles = {
  border: (lhs: BorderLHS) => {
    return `${lhs}: 1px solid var(--cds-color-neutral-stroke-primary-weak);`;
  },
};

export default styles;
